import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, mergeProps as _mergeProps, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_menu = _resolveComponent("v-menu")!

  return (_openBlock(), _createElementBlock("div", _normalizeProps(_guardReactiveProps(_ctx.$attrs)), [
    _createVNode(_component_v_menu, {
      "offset-y": "",
      "close-on-content-click": true
    }, {
      activator: _withCtx(({ props }) => [
        _createElementVNode("div", null, [
          _createElementVNode("div", _mergeProps({ class: "button-wrapper" }, props), [
            _createVNode(_component_v_btn, {
              elevation: 0,
              class: "first-button zamg-button-outline-primary",
              "data-testid": `${_ctx.testId}-tool-selection`,
              "min-width": "30px",
              width: "30px",
              height: "32px",
              onClick: _withModifiers(_ctx.handleButtonClick, ["stop"])
            }, {
              default: _withCtx(() => [
                (_ctx.selectedItem)
                  ? (_openBlock(), _createBlock(_component_v_icon, {
                      key: 0,
                      icon: _ctx.selectedItem?.icon
                    }, null, 8, ["icon"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["data-testid", "onClick"]),
            _createVNode(_component_v_btn, {
              elevation: 0,
              "data-testid": `${_ctx.testId}-tool-selection-dropdown`,
              class: "second-button zamg-button-outline-primary",
              "min-width": "20px",
              width: "20px",
              height: "32px"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_icon, { color: "primary" }, {
                  default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                    _createTextVNode(" mdi-chevron-down ", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["data-testid"])
          ], 16)
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_v_list, {
          density: "compact",
          class: "mt-1"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item, i) => {
              return (_openBlock(), _createBlock(_component_v_list_item, {
                key: i,
                "data-testid": item.testId,
                onClick: ($event: any) => (_ctx.handleItemChange(i))
              }, {
                prepend: _withCtx(() => [
                  _createVNode(_component_v_icon, {
                    icon: item.icon
                  }, null, 8, ["icon"])
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_v_list_item_title, null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(item.value), 1)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1032, ["data-testid", "onClick"]))
            }), 128))
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 16))
}